import { common } from './common.icons';

export const IconFreeShipping = ({ className = '', style = {}, ...rest }: any) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`icon-free-shipping ${common.classes} ${className}`}
      {...rest}
      style={{ ...common.styles, ...style }}
    >
      <path
        d="M5.26758 3.2998H10.7002V9.42285C10.7 9.74586 10.4354 10.0098 10.1123 10.0098H3.2998V5.26758C3.2998 4.17941 4.17941 3.2998 5.26758 3.2998Z"
        fill="#2563EB"
        stroke="#2563EB"
        strokeWidth="1.6"
      />
      <path
        d="M12.6006 11.1055C12.7207 12.0081 13.2906 12.7662 14.0781 13.1514C13.7423 13.0235 13.3797 12.9502 13 12.9502C11.5973 12.9502 10.4107 13.9065 10.0576 15.2002H9.94238C9.58927 13.9065 8.4027 12.9502 7 12.9502C5.65307 12.9502 4.50633 13.8323 4.10449 15.0479C3.6273 14.811 3.2998 14.3207 3.2998 13.75V12.2998H10.375C11.304 12.2998 12.121 11.8248 12.6006 11.1055ZM14.3154 13.2529C14.6068 13.3618 14.9208 13.4248 15.25 13.4248H16.7002V13.75C16.7002 14.321 16.3721 14.8111 15.8945 15.0479C15.6332 14.2575 15.0573 13.6104 14.3154 13.2529ZM13.6299 5.5498C13.8778 5.5498 14.1128 5.68464 14.2432 5.90918L14.2959 6.00293C13.7881 6.19717 13.3546 6.54008 13.0498 6.98047V5.5498H13.6299Z"
        fill="#2563EB"
        stroke="#2563EB"
        strokeWidth="1.6"
      />
      <path
        d="M7 15.2998C7.3866 15.2998 7.7002 15.6134 7.7002 16C7.7002 16.3866 7.3866 16.7002 7 16.7002C6.6134 16.7002 6.2998 16.3866 6.2998 16C6.2998 15.6134 6.6134 15.2998 7 15.2998Z"
        fill="#2563EB"
        stroke="#2563EB"
        strokeWidth="1.6"
      />
      <path
        d="M13 15.2998C13.3866 15.2998 13.7002 15.6134 13.7002 16C13.7002 16.3866 13.3866 16.7002 13 16.7002C12.6134 16.7002 12.2998 16.3866 12.2998 16C12.2998 15.6134 12.6134 15.2998 13 15.2998Z"
        fill="#2563EB"
        stroke="#2563EB"
        strokeWidth="1.6"
      />
      <path
        d="M17.5 10.3975V11.5H15.25C14.8375 11.5 14.5 11.1625 14.5 10.75V8.5C14.5 8.0875 14.8375 7.75 15.25 7.75H16.2175L17.305 9.655C17.4325 9.88 17.5 10.135 17.5 10.3975Z"
        fill="#2563EB"
      />
    </svg>
  );
};
